const PHASE_DEFINITIONS = [
    {
        id: 'phase-quickwins',
        title: 'Fase 1: Quick wins (dag 0-30)',
        description: 'Direct te starten activiteiten waar geen externe doorlooptijd voor nodig is. Focus op planvorming, contractuele borging en verifieerbare processen.',
        startDayOffset: 0,
        endDayOffset: 30,
        acceptsPriorities: ['critical', 'high'],
        maxEffortDays: 5,
    },
    {
        id: 'phase-foundation',
        title: 'Fase 2: Fundament leggen (dag 30-60)',
        description: 'Inrichten van structurele compliance-processen, certificeringstrajecten starten en juridische documenten herzien.',
        startDayOffset: 30,
        endDayOffset: 60,
        acceptsPriorities: ['critical', 'high', 'medium'],
        maxEffortDays: 12,
    },
    {
        id: 'phase-completion',
        title: 'Fase 3: Afronden & borgen (dag 60-90)',
        description: 'Lopende certificeringen afronden, financieringsopties vastleggen en de organisatie klaar maken voor toezicht en audits.',
        startDayOffset: 60,
        endDayOffset: 90,
        acceptsPriorities: ['critical', 'high', 'medium', 'low'],
        maxEffortDays: Number.POSITIVE_INFINITY,
    },
];
export function generatePlanning(recommendations) {
    const phases = PHASE_DEFINITIONS.map((def) => ({
        id: def.id,
        title: def.title,
        description: def.description,
        startDayOffset: def.startDayOffset,
        endDayOffset: def.endDayOffset,
        tasks: [],
    }));
    for (const rec of recommendations) {
        const phaseIndex = pickPhaseIndex(rec);
        const phase = phases[phaseIndex];
        if (!phase)
            continue;
        const phaseDef = PHASE_DEFINITIONS[phaseIndex];
        if (!phaseDef)
            continue;
        const startDayOffset = phaseDef.startDayOffset + (phase.tasks.length > 0
            ? Math.min(phase.tasks.length * 3, phaseDef.endDayOffset - phaseDef.startDayOffset - 1)
            : 0);
        const cappedDuration = Math.min(rec.estimatedEffortDays, phaseDef.endDayOffset - startDayOffset);
        const task = {
            id: `task-${rec.id}`,
            recommendationId: rec.id,
            title: rec.title,
            description: rec.description,
            startDayOffset,
            durationDays: Math.max(1, cappedDuration),
            category: rec.category,
        };
        phase.tasks.push(task);
    }
    return phases;
}
function pickPhaseIndex(rec) {
    for (let i = 0; i < PHASE_DEFINITIONS.length; i++) {
        const def = PHASE_DEFINITIONS[i];
        if (!def)
            continue;
        const priorityFits = def.acceptsPriorities.includes(rec.priority);
        const effortFits = rec.estimatedEffortDays <= def.maxEffortDays;
        if (priorityFits && effortFits) {
            return i;
        }
    }
    return PHASE_DEFINITIONS.length - 1;
}
//# sourceMappingURL=planning.js.map